import Form from "../../gui/Form/Form";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import { IMeal } from "../../shared/Meals";
import { MealsFullscreen } from "../Dialogs/FullscreenDlg";
import MealsCache from "../../data/MealsCache";
import MealEditor from "./MealEditor";
import MealViewer from "./MealViewer";
import RecipesProvider from "../RecipesProvider";

function MealDlg() {
    const {edit} = MealsFullscreen.useFullscreen()
    const content = edit ? <Form><MealEditor/></Form> : <MealViewer/>
    return <RecipesProvider>{content}</RecipesProvider>
}

export default function useViewMeal(){
    const {FullscreenDlg} = MealsFullscreen
    const {addOverlay,hasOverlay,popOverlay} = useOverlay()

    const viewMeal = (recipe:IMeal|undefined) => recipe && !hasOverlay("meal") && addOverlay("meal", {
        modal: true,
        children:<FullscreenDlg overlayId="meal" item={recipe} cache={MealsCache.i} content={<MealDlg/>}/>,
        className:"dialog fullscreen"})

    const hideMeal = () => popOverlay("meal")

    return {viewMeal,hideMeal}
}
